import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

/**
 * Asks for confirmation before leaving the page while `when` is true.
 *
 * This used to be hand-rolled on top of `UNSAFE_NavigationContext.navigator.block`,
 * a private react-router API that only existed up to 6.3 and was removed when data
 * routers landed in 6.4. The react-admin v5 upgrade brought react-router 7, so that
 * call threw "n.block is not a function" as soon as one of the bulk-create screens
 * mounted.
 *
 * react-router now ships `useBlocker` as public API, which does the same job. It
 * requires a data router, which react-admin's <Admin> provides.
 *
 * Note this only guards in-app navigation, same as the old implementation did.
 * Closing or reloading the tab needs a `beforeunload` listener, which we do not set.
 *
 * @param {string} message text shown in the confirmation dialog
 * @param {boolean} when whether navigation should be blocked
 */
export function usePrompt(message, when) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state !== "blocked") return;

    if (window.confirm(message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);
}
